/**
 * Derived on the backend from the order bill amounts — never stored.
 * Independent of OrderStatus: a counter order is Paid while still being prepared.
 *
 * Note: Unpaid is 0, so always compare explicitly rather than relying on truthiness.
 */
export enum PaymentStatus {
  Unpaid = 0,
  Partial = 1,
  Paid = 2
}
